import { ButtonBase } from "@mui/material";
import { useIntl } from "react-intl";

import { Image } from "@/components/Image/Image";
import type { Trip } from "@/features/trips/types/types";
import { formatCurrency } from "@/utils/currency";

type Props = {
  trip: Trip;
  onClick: () => void;
};

export const TripCarouselCard = ({ trip, onClick }: Props) => {
  const intl = useIntl();

  const imageUrl = trip.imageUrls[0];

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        backgroundColor: "var(--color-white)",
        borderRadius: "var(--radius-2xl)",
        border: "1px solid var(--color-stroke-neutral-soft)",
        width: "100%",
        textAlign: "initial",
        overflow: "clip",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
      }}
      disableTouchRipple
    >
      <Image
        src={imageUrl}
        alt={trip.name}
        className="full-w aspect-17/10 shrink-0 object-cover object-center"
      />

      <div className="flex grow flex-col p-3.5 text-text-primary">
        <div className="mb-5 line-clamp-2 grow text-lg font-semibold">
          {trip.name}
        </div>

        {trip.price !== trip.discountedPrice ? (
          <div className="text-sm font-medium text-semantic-error-strong line-through">
            {formatCurrency(trip.price)}
          </div>
        ) : null}
        <div className="text-base font-bold">
          {intl.formatMessage(
            { id: "trips.priceFrom" },
            { price: formatCurrency(trip.discountedPrice) },
          )}
        </div>
        <div className="text-xs font-medium">
          {intl.formatMessage({ id: "trips.perPerson" })}{" "}
          <span className="text-[#D9D9D9]">&bull;</span>{" "}
          {intl.formatMessage(
            { id: "trips.duration" },
            { nights: trip.durationInDays - 1, days: trip.durationInDays },
          )}
        </div>
      </div>
    </ButtonBase>
  );
};
